import {css} from 'aphrodite';
import classNames from 'classnames';
import React, {useRef} from 'react';
import _ from 'underscore';

import HelpToolTip from 'help/HelpTooltip';
import {sharedStyles} from 'processes/settings/fields/ProcessTaskSchemaFieldConstants';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';

interface AutopopulateFromTasksFieldProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
}

export default function AutopopulateFromTasksField(props: AutopopulateFromTasksFieldProps): JSX.Element {
  const wrapperIdRef = useRef(_.uniqueId('autopopulateFromTasksWrapper'));
  const checkboxIdRef = useRef(_.uniqueId('autopopulateFromTasksCheckbox'));

  return (
    <InputWrapper
      id={wrapperIdRef.current}
      label="Auto-populate from tasks"
      labelStyle={FieldLabel.STYLES.LABEL}
    >
      <div className={classNames(css(sharedStyles.checkboxWrapper), 'editableField')}>
        <CheckboxInput
          id={checkboxIdRef.current}
          className={css(sharedStyles.checkboxField)}
          label="Pre-fill one output per task"
          checked={props.value}
          disabled={props.disabled}
          onChange={(e) => {
            props.onChange(e.target.checked);
          }}
        />
        <HelpToolTip text="Enabling this option does not prevent users from adding, removing, or modifying outputs" />
      </div>
    </InputWrapper>
  );
}
